/* Built In Imports*/
import { useEffect } from 'react';
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components  */
/* Services */
/**
 * Renders the FC Health Component
 *
 * @param
 * @returns {ReactElement} - FC Health Component
 */
const HealthChatBot = () => {
  useEffect(() => {
    // Utility to load external script with a Promise
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => {
          console.log(`${src} loaded`);
          resolve(script);
        };
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.body.appendChild(script);
      });
    };

    loadScript('https://snippets.freshchat.com/js/fc-pre-chat-form-v2.min.js')
      .then(() => {
        return setTimeout(function () {loadScript('https://ishasupport.freshchat.com/js/widget.js')}, 3000);
      })
      .then(() => {
        const preChatTemplate = {
          mainbgColor: '#000084',
          maintxColor: '#fff',
          heading: 'Isha Health',
          textBanner: "We can't wait to talk to you. But first, please take a couple of moments to tell us a bit about yourself.",
          SubmitLabel: 'Start Chat',
          fields: {
            field2: {
              type: 'name',
              label: 'Name',
              fieldId: 'name',
              required: 'yes',
              error: 'Please Enter a valid name',
            },
            field3: {
              type: 'email',
              label: 'Email',
              fieldId: 'email',
              required: 'yes',
              error: 'Please Enter a valid Email',
            },
            field4: {
              type: 'phone',
              label: 'Phone',
              fieldId: 'phone',
              required: 'no',
              error: 'Please Enter a valid Phone Number',
            },
            field5: {
              type: 'textarea',
              label: 'Question',
              fieldId: 'question',
              required: 'yes',
              error: 'Please Enter your question',
            },
          },
        };

        // Freshchat settings
        window.fcSettings = {
          token: '1cefb6e2-f5fa-4e56-9abd-393e9708ffc4',
          host: 'https://ishasupport.freshchat.com',
          widgetUuid: 'e06f0b26-02a6-48ce-8f16-25c82f8af508',
          config: {
            cssNames: {
              widget: 'custom_fc_frame',
              expanded: 'custom_fc_expanded',
            },
          },
          onInit: function () {
            console.log('Freshchat initialized');
            if (window.fcPreChatform) {
              window.fcPreChatform.fcWidgetInit(preChatTemplate);
            } else {
              console.error('Chatform is not available');
            }
          },
        };

        if (window.fcWidget && window.fcSettings) {
          window.fcWidget.init();
        } else {
          console.error('Freshchat widget or settings not available');
        }
      })
      .catch((error) => {
        console.error('Error loading scripts:', error);
      });

    return () => {
      const script1 = document.querySelector('script[src="https://snippets.freshchat.com/js/fc-pre-chat-form-v2.min.js"]');
      const script2 = document.querySelector('script[src="https://ishasupport.freshchat.com/js/widget.js"]');
      if (script1) document.body.removeChild(script1);
      if (script2) document.body.removeChild(script2);
    };
  }, []);

  return <Box id="fc-widget-container"></Box>;
};

export default HealthChatBot;
